/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import { createContext } from 'react';

export interface IRoleContext {
  hasDriverRole: boolean;
  hasHostRole: boolean;
  hasEmployeeRole: boolean;
  hasAdminRole: boolean;
  hasAccountOwnerRole: boolean;
  hasHospitalityRole: boolean;
  hasFinanceRole: boolean;
  hasEngRole: boolean;
}

export const defaultRoleContext = {
  hasDriverRole: true,
  hasHostRole: true,
  hasEmployeeRole: false,
  hasAdminRole: false,
  hasAccountOwnerRole: false,
  hasHospitalityRole: false,
  hasFinanceRole: false,
  hasEngRole: false,
};

export default createContext<IRoleContext>(defaultRoleContext);
